import { render, staticRenderFns } from "./BriqTreeBranch.vue?vue&type=template&id=89b57534&scoped=true&lang=pug&"
import script from "./BriqTreeBranch.vue?vue&type=script&lang=js&"
export * from "./BriqTreeBranch.vue?vue&type=script&lang=js&"
import style0 from "./BriqTreeBranch.vue?vue&type=style&index=0&id=89b57534&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b57534",
  null
  
)

export default component.exports